// import React, { useEffect, useRef, useState } from "react";
// import { mapTableRows } from "../../../../utils/mapTableRows";
// import {
//   Alert,
//   Backdrop,
//   Button,
//   FormFieldSet,
//   LogoLoader,
//   Modal,
//   NewTable,
//   showToast,
// } from "../../../../components";
// import CustomSection from "../../../../components/Common/CustomSection";
// import { approvalDelegationData } from "../../../../assets/data/candidatesData";
// import {
//   bulkUpdateEmployeeStart,
//   clearEmployeeData,
//   getEmployeesStart,
//   updateEmployeeStart,
// } from "../../../../redux/slices/employee/employeeSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { usePagination } from "../../../../hooks";
// import { getEmployeeId } from "../../../../utils";
// import useDropdownData from "../../../../hooks/useDropdownData";
// import { getEmployeeName } from "../../../../utils/getDisplays";

// const ApprovalDelegation = () => {
//   const containerRef = useRef(null);

//   const dispatch = useDispatch();
//   const { loading, error, employees, totalCount } = useSelector(
//     (state) => state.employee,
//   );

//   const [user, setUser] = useState("");
//   const [employee, setEmployee] = useState("");

//   const [changeApproverModal, setChangeApproverModal] = useState(false);
//   const [removeApproverModal, setRemoveApproverModal] = useState(false);
//   const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
//   const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);
//   console.log("selectedEmployeeIds", selectedEmployeeIds);
//   useEffect(() => {
//     const fetchEmployees = async () => {
//       //fetching with api
//       // const promises = selectedEmployeeIds.map(async (id) => {
//       //   const name = await getEmployeeName(id);
//       //   return name;
//       // });
//       // const names = await Promise.all(promises);
//       // setSelectedEmployeeNames(names);
//       // fetchging with existing data
//       const namesList =
//         employees?.data
//           ?.filter((employee) =>
//             selectedEmployeeIds.includes(String(employee.uiid)),
//           )
//           .map((employee) =>
//             [employee.firstName, employee.lastName].filter(Boolean).join(" "),
//           ) || [];
//       setSelectedEmployeeNames(namesList);
//     };
//     if (selectedEmployeeIds.length > 0) {
//       fetchEmployees();
//     }
//   }, [selectedEmployeeIds]);

//   const tableData = approvalDelegationData;
//   // dropdown hook
//   const {
//     data: allSelectEmployeeListOptions,
//     searchValue: allSelectEmployeeSearch,
//     handleSearch: handleSelectEmployeeSearch,
//     resetSearch: resetAllSelectEmployeeSearch,
//     handleScroll: handleAllSelectEmployeeScroll,
//   } = useDropdownData(
//     "employeesSorted",
//     10,
//     {},
//     {
//       classification: 2,
//     },
//   );
//   // pagination
//   const { page, limit, setPage, handleLimitChange } = usePagination(
//     10,
//     (newPage, newLimit) => {
//       dispatch(
//         getEmployeesStart({
//           page: newPage,
//           limit: newLimit,
//           filters: {
//             classification: {
//               type: "NONE",
//               value: 1,
//             },
//           },
//           sort: { uiid: -1 },
//           // sort: { uiid: 1 },
//           ret: "uiid firstName lastName approvalFlow.delegator employmentType",
//           ref: "Approver",
//           incl: "uiid firstName lastName employmentType",
//         }),
//       );
//     },
//   );

//   const columns = [
//     { key: "employeeName", label: "Employee Name", sortable: false },
//     {
//       key: "approvalDelegation",
//       label: "Approval Delegation",
//       sortable: false,
//     },
//   ];

//   // const mappedRows = mapTableRows(tableData, columns);
//   //   {
//   //   id: 1,
//   //   employeeName: "Abdul Waseem Syed (EMP-1001)",
//   //   approvalDelegation: "Hemalatha Medisetti (EMP-075)",
//   // },
//   // {
//   //mapping
//   const mappedRows = mapTableRows(
//     employees?.data?.map((emp) => ({
//       id: emp?.uiid,
//       employeeName:
//         [emp?.firstName, emp?.lastName].filter(Boolean).join(" ") +
//         " (" +
//         getEmployeeId(emp.uiid, emp.employmentType) +
//         ")",
//       approvalDelegation:
//         emp?.approvalFlow?.approvers?.length > 0 &&
//         emp?.approvalFlow?.approvers[0]
//           ? [
//               emp?.approvalFlow?.approvers[0]?.firstName,
//               emp?.approvalFlow?.approvers[0]?.lastName,
//             ]
//               .filter(Boolean)
//               .join(" ") +
//             " (" +
//             getEmployeeId(
//               emp?.approvalFlow?.approvers[0]?.uiid,
//               emp?.approvalFlow?.approvers[0]?.employmentType,
//             ) +
//             ")"
//           : "-",
//     })),
//     columns,
//   );
//   // get employees table
//   useEffect(() => {
//     dispatch(
//       getEmployeesStart({
//         page: page,
//         limit: limit,
//         filters: {
//           classification: {
//             type: "NONE",
//             value: 1,
//           },
//         },
//         sort: { uiid: -1 },
//         // sort: { uiid: 1 },
//         ret: "uiid firstName lastName approvalFlow employmentType",
//         ref: "Approver",
//         incl: "uiid firstName lastName employmentType",
//       }),
//     );
//     return () => {
//       dispatch(clearEmployeeData());
//     };
//   }, [dispatch, page, limit]); // Empty array will cause it to run once when the component mounts

//   //working
//   // const handleChangeApprover = async () => {
//   //   if (!selectedEmployeeIds.length) {
//   //     showToast("Please select an employee", "error", 5000);
//   //     return;
//   //   }

//   //   try {
//   //     for (const id of selectedEmployeeIds) {
//   //       try {
//   //         await Promise.all([
//   //           dispatch(
//   //             updateEmployeeStart({
//   //               coll: "Employee",
//   //               uiid: id,
//   //               payload: [
//   //                 {
//   //                   type: "SET",
//   //                   value: { "approvalFlow.approvers.0": user },
//   //                 },
//   //               ],
//   //             })
//   //           ),
//   //           dispatch(
//   //             updateEmployeeStart({
//   //               coll: "Employee",
//   //               uiid: user,
//   //               payload: [
//   //                 {
//   //                   type: "PUSH",
//   //                   value: {
//   //                     "approvalFlow.approverTo": id,
//   //                   },
//   //                 },
//   //               ],
//   //             })
//   //           ),
//   //         ]).then(() => {
//   //           setUser("");
//   //           setChangeApproverModal(false);

//   //           setTimeout(() => {
//   //             dispatch(
//   //               getEmployeesStart({
//   //                 page,
//   //                 limit,
//   //                 filters: {
//   //                   classification: {
//   //                     type: "NONE",
//   //                     value: 1,
//   //                   },
//   //                 },
//   //                 sort: { uiid: -1 },
//   //                 ret: "uiid firstName lastName approvalFlow employmentType",
//   //                 ref: "Approver",
//   //                 incl: "uiid firstName lastName",
//   //               })
//   //             );
//   //           }, 1200);
//   //         });
//   //       } catch (err) {
//   //         showToast(`Failed to update employee ${id}`, "error", 5000);
//   //         console.error(`Error updating employee ${id}:`, err);
//   //         throw err; // Remove this line if you want to continue even after one fails
//   //       }
//   //     }
//   //   } catch (finalError) {
//   //     showToast("Bulk update failed. Please try again later.", "error", 5000);
//   //     console.error("Bulk update error:", finalError);
//   //   }
//   // };

//   const handleChangeApprover = async () => {
//     if (!selectedEmployeeIds.length) {
//       showToast("Please select an employee", "error", 5000);
//       return;
//     }
//     let selectedEmployeesDataToFilter = employees?.data?.filter((emp) =>
//       selectedEmployeeIds.includes(String(emp.uiid)),
//     );
//     const newIdWithoutUSerAsApprover = selectedEmployeesDataToFilter
//       .map((employee) => {
//         if (
//           employee.approvalFlow.approvers.some(
//             (approver) => approver.uiid === user,
//           )
//         ) {
//           return null;
//         } else {
//           return employee.uiid;
//         }
//       })
//       .filter((el) => el);

//     // console.log(
//     //   "employees with selectedEmployeeIds as uiid:",
//     //   newIdWithoutUSerAsApprover
//     // );

//     try {
//       dispatch(
//         bulkUpdateEmployeeStart({
//           coll: "Employee",
//           uiid: null,
//           payload: [
//             {
//               type: "UPDATEMANY",
//               value: {
//                 type: "SET",
//                 value: {
//                   "approvalFlow.approvers.0": user,
//                 },
//                 fil: {
//                   uiid: {
//                     type: "IN",
//                     value: selectedEmployeeIds?.map((id) => Number(id)),
//                   },
//                 },
//               },
//             },
//             {
//               type: "UPDATEONE",
//               value: {
//                 type: "PUSH",
//                 value: {
//                   // "approvalFlow.approverTo": selectedEmployeeIds,
//                   "approvalFlow.approverTo": newIdWithoutUSerAsApprover,
//                 },
//                 fil: {
//                   uiid: { type: "NONE", value: user },
//                 },
//               },
//             },
//           ],
//           onSuccess: () => {
//             setTimeout(() => {
//               dispatch(
//                 getEmployeesStart({
//                   page,
//                   limit,
//                   filters: {
//                     classification: {
//                       type: "NONE",
//                       value: 1,
//                     },
//                   },
//                   sort: { uiid: -1 },
//                   ret: "uiid firstName lastName approvalFlow employmentType",
//                   ref: "Approver",
//                   incl: "uiid firstName lastName",
//                 }),
//               );
//             }, 500);
//           },
//         }),
//       );

//       setUser("");
//       setChangeApproverModal(false);

//       // setTimeout(() => {
//       //   dispatch(
//       //     getEmployeesStart({
//       //       page,
//       //       limit,
//       //       filters: {
//       //         classification: {
//       //           type: "NONE",
//       //           value: 1,
//       //         },
//       //       },
//       //       sort: { uiid: -1 },
//       //       ret: "uiid firstName lastName approvalFlow employmentType",
//       //       ref: "Approver",
//       //       incl: "uiid firstName lastName",
//       //     })
//       //   );
//       // }, 1200);
//     } catch (err) {
//       console.error(err);
//       showToast("Bulk update failed. Please try again later.", "error", 5000);
//     }
//   };

//   //working
//   const handleRemoveApprover = async () => {
//     if (!selectedEmployeeIds.length) {
//       showToast("Please select an employee", "error", 5000);
//       return;
//     }

//     try {
//       const updatePromises = selectedEmployeeIds.map((id) => {
//         const employee = employees?.data?.find(
//           (emp) => String(emp?.uiid) === id,
//         );
//         const approverId = employee?.approvalFlow?.approvers?.[0]?.uiid;

//         return Promise.all([
//           dispatch(
//             updateEmployeeStart({
//               coll: "Employee",
//               uiid: id,
//               payload: [
//                 {
//                   type: "PULL",
//                   value: {
//                     "approvalFlow.approvers": Number(approverId),
//                   },
//                 },
//               ],
//             }),
//           ),
//           dispatch(
//             updateEmployeeStart({
//               coll: "Employee",
//               uiid: Number(approverId),
//               payload: [
//                 {
//                   type: "PULL",
//                   value: {
//                     "approvalFlow.approverTo": Number(id),
//                   },
//                 },
//               ],
//             }),
//           ),
//         ]);
//       });

//       await Promise.all(updatePromises).then(() => {
//         setRemoveApproverModal(false);

//         // setTimeout(() => {
//         //   dispatch(
//         //     getEmployeesStart({
//         //       page,
//         //       limit,
//         //       filters: {
//         //         classification: {
//         //           type: "NONE",
//         //           value: 1,
//         //         },
//         //       },
//         //       sort: { uiid: -1 },
//         //       ret: "uiid firstName lastName approvalFlow employmentType",
//         //       ref: "Delegator",
//         //       incl: "uiid firstName lastName",
//         //     })
//         //   );
//         // }, 1);
//       });
//     } catch (error) {
//       showToast(
//         "Failed to remove approver(s). Please try again.",
//         "error",
//         5000,
//       );
//     } finally {
//       setTimeout(() => {
//         dispatch(
//           getEmployeesStart({
//             page,
//             limit,
//             filters: {
//               classification: {
//                 type: "NONE",
//                 value: 1,
//               },
//             },
//             sort: { uiid: -1 },
//             ret: "uiid firstName lastName approvalFlow employmentType",
//             ref: "Approver",
//             incl: "uiid firstName lastName",
//           }),
//         );
//       }, 1200);
//     }
//   };
//   //with bulk api
//   // const handleRemoveApprover = async () => {
//   //   if (!selectedEmployeeIds.length) {
//   //     showToast("Please select an employee", "error", 5000);
//   //     return;
//   //   }

//   //   try {
//   //     const approverMappings = selectedEmployeeIds.map((id) => {
//   //       const employee = employees?.data?.find((emp) => emp?.uiid === id);
//   //       return {
//   //         id,
//   //         approverId: employee?.approvalFlow?.approvers?.[0]?.uiid,
//   //       };
//   //     });

//   //     const employeeIds = approverMappings.map((item) => item.id);
//   //     const approverIds = approverMappings
//   //       .map((item) => item.approverId)
//   //       .filter(Boolean);

//   //     dispatch(
//   //       bulkUpdateEmployeeStart({
//   //         coll: "Employee",
//   //         uiid: null,
//   //         payload: [
//   //           {
//   //             type: "UPDATEMANY",
//   //             value: {
//   //               type: "PULL",
//   //               value: {
//   //                 "approvalFlow.approvers": approverIds,
//   //               },
//   //               fil: {
//   //                 uiid: { type: "IN", value: employeeIds },
//   //               },
//   //             },
//   //           },
//   //           {
//   //             type: "UPDATEMANY",
//   //             value: {
//   //               type: "PULL",
//   //               value: {
//   //                 "approvalFlow.approverTo": employeeIds,
//   //               },
//   //               fil: {
//   //                 uiid: { type: "IN", value: approverIds },
//   //               },
//   //             },
//   //           },
//   //         ],
//   //       })
//   //     );

//   //     setRemoveApproverModal(false);

//   //     setTimeout(() => {
//   //       dispatch(
//   //         getEmployeesStart({
//   //           page,
//   //           limit,
//   //           filters: {
//   //             classification: {
//   //               type: "NONE",
//   //               value: 1,
//   //             },
//   //           },
//   //           sort: { uiid: -1 },
//   //           ret: "uiid firstName lastName approvalFlow employmentType",
//   //           ref: "Delegator",
//   //           incl: "uiid firstName lastName",
//   //         })
//   //       );
//   //     }, 1200);
//   //   } catch (error) {
//   //     showToast(
//   //       "Failed to remove approver(s). Please try again.",
//   //       "error",
//   //       5000
//   //     );
//   //   }
//   // };

//   return (
//     <div className="flex-1 flex overflow-hidden">
//       <Backdrop isOpen={loading}>
//         <LogoLoader />
//       </Backdrop>
//       <NewTable
//         showCheckbox
//         rows={mappedRows}
//         columns={columns}
//         serverPagination={true}
//         totalCount={totalCount?.data}
//         page={page}
//         limit={limit}
//         onPageChange={setPage}
//         onLimitChange={handleLimitChange}
//         onSelectionChange={(change) => {
//           setSelectedEmployeeIds(change);
//         }}
//         toolbarRight={[
//           { filterButton: false },
//           { DropdownMenu: false },
//           // {hideToolbar:true}
//         ]}
//         tableWidth={"max-w-7xl"}
//         customSection={
//           selectedEmployeeIds.length > 0 && (
//             <CustomSection>
//               <Button
//                 variant="contained"
//                 size="sm"
//                 title={"Change Approver"}
//                 onClick={() => setChangeApproverModal(true)}
//                 color="black"
//                 icon="person_add"
//               />
//               <Button
//                 variant="contained"
//                 size="sm"
//                 title={"Remove Approver"}
//                 onClick={() => setRemoveApproverModal(true)}
//                 color="black"
//                 icon="person_remove"
//               />
//             </CustomSection>
//           )
//         }
//       />
//       <Modal
//         isOpen={changeApproverModal}
//         onClose={() => setChangeApproverModal(false)}
//         title="Change Approver"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="flex flex-col max-w-[50%] gap-3">
//             <div className="">
//               <FormFieldSet
//                 type={"select"}
//                 title={"User"}
//                 placeholder="Select Approver"
//                 value={user}
//                 onChange={setUser}
//                 options={allSelectEmployeeListOptions}
//                 keyname="employeesSorted"
//                 showSearch
//                 searchValue={allSelectEmployeeSearch}
//                 onClose={resetAllSelectEmployeeSearch}
//                 refData={containerRef}
//                 onSearch={handleSelectEmployeeSearch}
//                 handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
//               />
//             </div>
//             <div>
//               <p>Can submit timesheets on behalf of:</p>
//             </div>
//             <div className="">
//               <FormFieldSet
//                 type={"textArea"}
//                 // placeholder=". Aaron carter (CON-2112)"
//                 placeholder="Selected Employee(s)"
//                 title="Employee(s)"
//                 // value={employee}
//                 // onChange={setEmployee}
//                 value={selectedEmployeeNames.join(", ")}
//                 disabled={true}
//               />
//             </div>
//           </div>
//           <div className="flex gap-3 justify-end">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => {
//                 setUser("");
//                 setChangeApproverModal(false);
//               }}
//             />
//             <Button
//               title={"OK"}
//               // onClick={() => setChangeApproverModal(false)}
//               onClick={handleChangeApprover}
//             />
//           </div>
//         </div>
//       </Modal>
//       <Modal
//         isOpen={removeApproverModal}
//         onClose={() => setRemoveApproverModal(false)}
//         title="Remove Approver"
//         width="max-w-4xl"
//       >
//         <div>
//           <div className="mb-20">
//             <p>
//               Are you sure you want to remove the assigned delegate from the
//               selected employee(s) ?
//             </p>
//           </div>
//           <div className="flex gap-3 justify-end">
//             <Button
//               variant="outlined"
//               title={"Cancel"}
//               onClick={() => setRemoveApproverModal(false)}
//             />
//             <Button title={"OK"} onClick={handleRemoveApprover} />
//           </div>
//         </div>
//       </Modal>
//     </div>
//   );
// };

// export default ApprovalDelegation;
import React, { useEffect, useRef, useState } from "react";
import { mapTableRows } from "../../../../utils/mapTableRows";
import {
  Alert,
  Backdrop,
  Button,
  FormFieldSet,
  LogoLoader,
  Modal,
  TableAdv,
  showToast,
} from "../../../../components";
import CustomSection from "../../../../components/Common/CustomSection";
import { approvalDelegationData } from "../../../../assets/data/candidatesData";
import {
  bulkUpdateEmployeeStart,
  clearEmployeeData,
  getEmployeesStart,
  updateEmployeeStart,
} from "../../../../redux/slices/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { usePagination } from "../../../../hooks";
import { getEmployeeId } from "../../../../utils";
import useDropdownData from "../../../../hooks/useDropdownData";
import { getEmployeeName } from "../../../../utils/getDisplays";

const ApprovalDelegation = () => {
  const containerRef = useRef(null);

  const dispatch = useDispatch();
  const { loading, error, employees, totalCount } = useSelector(
    (state) => state.employee,
  );

  const [user, setUser] = useState("");
  const [employee, setEmployee] = useState("");

  const [changeApproverModal, setChangeApproverModal] = useState(false);
  const [removeApproverModal, setRemoveApproverModal] = useState(false);
  const [selectedEmployeeIds, setSelectedEmployeeIds] = useState([]);
  const [selectedEmployeeNames, setSelectedEmployeeNames] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  console.log("selectedEmployeeIds", selectedEmployeeIds);

  useEffect(() => {
    const fetchEmployees = async () => {
      const namesList =
        employees?.data
          ?.filter((employee) =>
            selectedEmployeeIds.includes(String(employee.uiid)),
          )
          .map((employee) =>
            [employee.firstName, employee.lastName].filter(Boolean).join(" "),
          ) || [];
      setSelectedEmployeeNames(namesList);
    };
    if (selectedEmployeeIds.length > 0) {
      fetchEmployees();
    }
  }, [selectedEmployeeIds]);

  const tableData = approvalDelegationData;

  // dropdown hook
  const {
    data: allSelectEmployeeListOptions,
    searchValue: allSelectEmployeeSearch,
    handleSearch: handleSelectEmployeeSearch,
    resetSearch: resetAllSelectEmployeeSearch,
    handleScroll: handleAllSelectEmployeeScroll,
  } = useDropdownData(
    "employeesSorted",
    10,
    {},
    {
      classification: 2,
      // employmentType: [1,3],
    },
  );

  // pagination
  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getEmployeesStart({
          page: newPage,
          limit: newLimit,
          filters: {
            classification: {
              type: "NONE",
              value: 1,
            },
            employmentType: {
              type: "IN",
              value: [1,3],
            },
          },
          sort: { uiid: -1 },
          ret: "uiid firstName lastName approvalFlow.delegator employmentType",
          ref: "Approver",
          incl: "uiid firstName lastName employmentType",
        }),
      );
    },
  );

  const columns = [
    { key: "employeeName", label: "Employee Name", sortable: false },
    {
      key: "approvalDelegation",
      label: "Approval Delegation",
      sortable: false,
    },
  ];

  // Mapping rows with proper id field for TableAdv
  const mappedRows = mapTableRows(
    employees?.data?.map((emp) => ({
      id: emp?.uiid, // Important: Add id field for TableAdv
      uiid: emp?.uiid, // Keep uiid for reference
      employeeName:
        [emp?.firstName, emp?.lastName].filter(Boolean).join(" ") +
        " (" +
        getEmployeeId(emp.uiid, emp.employmentType) +
        ")",
      approvalDelegation:
        emp?.approvalFlow?.approvers?.length > 0 &&
        emp?.approvalFlow?.approvers[0]
          ? [
              emp?.approvalFlow?.approvers[0]?.firstName,
              emp?.approvalFlow?.approvers[0]?.lastName,
            ]
              .filter(Boolean)
              .join(" ") +
            " (" +
            getEmployeeId(
              emp?.approvalFlow?.approvers[0]?.uiid,
              emp?.approvalFlow?.approvers[0]?.employmentType,
            ) +
            ")"
          : "-",
    })) || [],
    columns,
  );

  // get employees table
  useEffect(() => {
    dispatch(
      getEmployeesStart({
        page: page,
        limit: limit,
        filters: {
          classification: {
            type: "NONE",
            value: 1,
          },
          employmentType: {
            type: "IN",
            value: [1,3],
          },
        },
        sort: { uiid: -1 },
        ret: "uiid firstName lastName approvalFlow employmentType",
        ref: "Approver",
        incl: "uiid firstName lastName employmentType",
      }),
    );
    return () => {
      dispatch(clearEmployeeData());
    };
  }, [dispatch, page, limit]);

  const handleChangeApprover = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("No employee selected. Please select at least one record to continue", "error", 5000);
      return;
    }
    let selectedEmployeesDataToFilter = employees?.data?.filter((emp) =>
      selectedEmployeeIds.includes(String(emp.uiid)),
    );
    const newIdWithoutUSerAsApprover = selectedEmployeesDataToFilter
      .map((employee) => {
        if (
          employee.approvalFlow.approvers.some(
            (approver) => approver.uiid === user,
          )
        ) {
          return null;
        } else {
          return employee.uiid;
        }
      })
      .filter((el) => el);

    try {
      dispatch(
        bulkUpdateEmployeeStart({
          coll: "Employee",
          uiid: null,
          payload: [
            {
              type: "UPDATEMANY",
              value: {
                type: "SET",
                value: {
                  "approvalFlow.approvers.0": user,
                },
                fil: {
                  uiid: {
                    type: "IN",
                    value: selectedEmployeeIds?.map((id) => Number(id)),
                  },
                },
              },
            },
            {
              type: "UPDATEONE",
              value: {
                type: "PUSH",
                value: {
                  "approvalFlow.approverTo": newIdWithoutUSerAsApprover,
                },
                fil: {
                  uiid: { type: "NONE", value: user },
                },
              },
            },
          ],
          onSuccess: () => {
            setTimeout(() => {
              dispatch(
                getEmployeesStart({
                  page,
                  limit,
                  filters: {
                    classification: {
                      type: "NONE",
                      value: 1,
                    },
                    employmentType: {
                      type: "IN",
                      value: [1,3],
                    },
                  },
                  sort: { uiid: -1 },
                  ret: "uiid firstName lastName approvalFlow employmentType",
                  ref: "Approver",
                  incl: "uiid firstName lastName",
                }),
              );
            }, 500);
          },
        }),
      );

      setUser("");
      setChangeApproverModal(false);
    } catch (err) {
      console.error(err);
      showToast("Bulk update failed. Some changes may not have been applied", "error", 5000);
    }
  };

  const handleRemoveApprover = async () => {
    if (!selectedEmployeeIds.length) {
      showToast("No employee selected. Please select at least one record to continue", "error", 5000);
      return;
    }

    try {
      const updatePromises = selectedEmployeeIds.map((id) => {
        const employee = employees?.data?.find(
          (emp) => String(emp?.uiid) === id,
        );
        const approverId = employee?.approvalFlow?.approvers?.[0]?.uiid;

        return Promise.all([
          dispatch(
            updateEmployeeStart({
              coll: "Employee",
              uiid: id,
              payload: [
                {
                  type: "PULL",
                  value: {
                    "approvalFlow.approvers": Number(approverId),
                  },
                },
              ],
            }),
          ),
          dispatch(
            updateEmployeeStart({
              coll: "Employee",
              uiid: Number(approverId),
              payload: [
                {
                  type: "PULL",
                  value: {
                    "approvalFlow.approverTo": Number(id),
                  },
                },
              ],
            }),
          ),
        ]);
      });

      await Promise.all(updatePromises).then(() => {
        setRemoveApproverModal(false);
      });
    } catch (error) {
      showToast(
        "Unable to remove selected approvers. Please try again",
        "error",
        5000,
      );
    } finally {
      setTimeout(() => {
        dispatch(
          getEmployeesStart({
            page,
            limit,
            filters: {
              classification: {
                type: "NONE",
                value: 1,
              },
            },
            sort: { uiid: -1 },
            ret: "uiid firstName lastName approvalFlow employmentType",
            ref: "Approver",
            incl: "uiid firstName lastName",
          }),
        );
      }, 1200);
    }
  };

  // Handle selection change from TableAdv
  const handleSelectionChange = (selectedRowIds) => {
    console.log("Selected row IDs from TableAdv:", selectedRowIds);
    console.log("All mapped rows:", mappedRows);

    setSelectedRows(selectedRowIds);

    // Find the actual row objects from mappedRows
    const selectedRowObjects = mappedRows.filter((row) =>
      selectedRowIds.includes(row.id),
    );

    console.log("Selected row objects:", selectedRowObjects);

    // Extract employee IDs (convert to string to match the format used in other functions)
    const employeeIds = selectedRowObjects.map((row) =>
      String(row.uiid || row.id),
    );

    console.log("Extracted employee IDs:", employeeIds);

    setSelectedEmployeeIds(employeeIds);
  };

  return (
    <div className="flex-1 flex overflow-hidden">
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <TableAdv
        showCheckbox
        rows={mappedRows}
        columns={columns}
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        onSelectionChange={handleSelectionChange}
        defaultSelectedRows={selectedRows}
        toolbarRight={{
          filter: false,
          search: false,
          add: [
            {
              component: selectedEmployeeIds.length > 0 && (
                <div className="flex items-center gap-2">
                  <Button
                    variant="contained"
                    size="sm"
                    title={"Change Approver"}
                    onClick={() => setChangeApproverModal(true)}
                    color="black"
                    icon="person_add"
                  />
                  <Button
                    variant="contained"
                    size="sm"
                    title={"Remove Approver"}
                    onClick={() => setRemoveApproverModal(true)}
                    color="black"
                    icon="person_remove"
                  />
                </div>
              ),
            },
          ],
        }}
        tableId="timesheet_timesheetsettinr_approvaldelegationtable"
      />
      <Modal
        isOpen={changeApproverModal}
        onClose={() => setChangeApproverModal(false)}
        title="Change Approver"
        width="max-w-4xl"
      >
        <div>
          <div className="flex flex-col max-w-[80%] lg:max-w-[65%] xl:max-w-[50%] gap-3">
            <div className="">
              <FormFieldSet
                type={"select"}
                title={"User"}
                placeholder="Select Approver"
                value={user}
                onChange={setUser}
                options={allSelectEmployeeListOptions}
                keyname="employeesSorted"
                showSearch
                searchValue={allSelectEmployeeSearch}
                onClose={resetAllSelectEmployeeSearch}
                refData={containerRef}
                onSearch={handleSelectEmployeeSearch}
                handleScroll={() => handleAllSelectEmployeeScroll(containerRef)}
              />
            </div>
            <div>
              <p>Can submit timesheets on behalf of:</p>
            </div>
            <div className="">
              <FormFieldSet
                type={"textArea"}
                placeholder="Selected Employee(s)"
                title="Employee(s)"
                value={selectedEmployeeNames.join(", ")}
                disabled={true}
              />
            </div>
          </div>
          <div className="flex gap-3 justify-end mt-2">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => {
                setUser("");
                setChangeApproverModal(false);
              }}
            />
            <Button title={"OK"} onClick={handleChangeApprover} />
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={removeApproverModal}
        onClose={() => setRemoveApproverModal(false)}
        title="Remove Approver"
        width="max-w-4xl"
      >
        <div>
          <div className="mb-20">
            <p>
              Are you sure you want to remove the assigned delegate from the
              selected employee(s) ?
            </p>
          </div>
          <div className="flex gap-3 justify-end">
            <Button
              variant="outlined"
              title={"Cancel"}
              onClick={() => setRemoveApproverModal(false)}
            />
            <Button title={"OK"} onClick={handleRemoveApprover} />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ApprovalDelegation;
